<template>
   <div>
       <application-title
           :title="$t('applications.motivation')"
       />

       <div v-if="application.motivation.trim().length" class="overflow-hidden mb-32">
           <p class="break-words whitespace-normal text-primary-80">{{ motivationPreview }}</p>

           <div v-if="motivationPreview.length < application.motivation.length"
                class="pt-32"
           >
               <button class="w-1/2 bg-primary-5 mx-auto font-semibold text-primary-80 text-center py-8 hover:bg-primary-5 hover:text-primary rounded focus:outline-none focus:text-primary flex items-center justify-center"
                       role="button"
                       @click="viewMotivation">
                   <svg-icon class="max-w-16 max-h-16 mr-10" type="visibility"></svg-icon>
                   <span>{{ $t('general.read_more') }}</span>
               </button>
           </div>
       </div>
       <p v-else class="whitespace pre-wrap text-primary-80 mb-32">{{ $t('applications.motivation_missing') }}</p>

       <popup-modal
           v-if="canView && viewingMotivation"
           :title="$t('applications.motivation') + ' ' + application.fullName"
           position="center"
           @close="closeMotivation"
       >
           <div class="max-w-768 text-body px-32 mb-16">
               <p class="whitespace-pre-wrap leading-relaxed">{{ application.motivation }}</p>
           </div>
       </popup-modal>
   </div>
</template>

<script>
import PopupModal from './ui/PopupModal.vue';
import _truncate from 'lodash/truncate';
import SvgIcon from './ui/SvgIcon.vue';
import ApplicationTitle from "./applications/ApplicationTitle.vue";

export default {
    name: 'ApplicationMotivation',
    components: {ApplicationTitle, SvgIcon, PopupModal},
    props: {
        application: Object,
        canView: Boolean,
    },
    data: function () {
        return {
            viewingMotivation: false,
        };
    },
    computed: {
        motivationPreview() {
            return _truncate(this.application.motivation, {
                length: 250,
                separator: '…',
            });
        },
    },
    methods: {
        viewMotivation() {
            this.viewingMotivation = true;
        },
        closeMotivation() {
            this.viewingMotivation = false;
        },
    },
};
</script>
